<div *ngIf="chartReady; else loading">
  <google-chart
    [type]="chartType"
    [columns]="chartColumns"
    [data]="chartData"
    [options]="chartOptions"
    [width]="1000"
    [height]="500">
  </google-chart>
</div>

<ng-template #loading>
  <div>Loading chart metadata and data...</div>
</ng-template>
